<template>
  <el-dialog
    :visible.sync="visible"
    :width="width"
    :title="title"
    :before-close="handleClose"
    append-to-body
    custom-class="SrDialogAddOptions"
  >
    <div class="dialog_content">
      <div class="searchPage">
        <SrSearch
          :search="search"
          :searchExpand="true"
          :showTextBtns="true"
          @queryList="pageChanged(1)"
        >
          <el-popover
            placement="top-start"
            width="auto"
            trigger="click"
            class="more_popover"
            :visible-arrow="false"
            popper-class="SrDialogAddOptionsPopover"
            slot="searchBtn"
            ref="SrDialogAddOptionsPopoverAdd"
            @show="add"
          >
            <div class="popover_container">
              <el-input
                v-model.trim="name"
                maxLength="10"
                placeholder="请输入分组名称"
                :required="false"
              >
              </el-input>
              <div class="container_footer">
                <el-button
                  size="small"
                  type="primary"
                  @click="popover_sumbit('add')"
                >
                  确认
                </el-button>
                <el-button size="small" @click="popover_close('add')">
                  取消
                </el-button>
              </div>
            </div>
            <el-button
              slot="reference"
              style="margin-left: 8px"
              size="small"
              round
              >新增</el-button
            >
          </el-popover>
        </SrSearch>
      </div>
      <SrTable
        @pageChanged="pageChanged"
        :data="table.data"
        ref="SrTable"
        @sizeChanged="sizeChanged"
        :config="table.tableConfig"
        :page="table.page"
      >
        <template v-slot:slotOperateConfig="data">
          <template v-for="(item, index) in data.btns">
            <el-popover
              placement="top-start"
              width="auto"
              trigger="click"
              class="more_popover"
              :visible-arrow="false"
              popper-class="SrDialogAddOptionsPopover"
              v-if="item.name == '编辑'"
              :key="item.name"
              style="margin-right:8px"
              ref="SrDialogAddOptionsPopoverEdit"
              @show="edit(item, data)"
            >
              <div class="popover_container">
                <el-input
                  v-model.trim="name"
                  maxLength="10"
                  placeholder="请输入分组名称"
                  :required="false"
                >
                </el-input>
                <div class="container_footer">
                  <el-button
                    size="small"
                    type="primary"
                    @click="popover_sumbit('edit')"
                  >
                    确认
                  </el-button>
                  <el-button size="small" @click="popover_close('edit')">
                    取消
                  </el-button>
                </div>
              </div>
              <el-button
                @click.stop
                class="more_btns"
                slot="reference"
                type="text"
              >
                编辑
              </el-button>
            </el-popover>
            <el-button
              :key="index"
              :type="item.type"
              size="medium"
              v-else
              @click="callFn(item, data, item.name)"
              >{{ item.name }}</el-button
            >
          </template>
        </template>
      </SrTable>
    </div>
    <div class="dialog_footer">
      <el-button v-if="type == 'warning'" size="medium" @click="$emit('close')">
        取消
      </el-button>
      <el-button
        v-if="type == 'warning'"
        size="medium"
        type="primary"
        @click="$emit('ok')"
      >
        确认
      </el-button>
      <el-button v-else @click="$emit('close')" size="mini" round
        >关闭</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "SrDialogAddOptions",
  props: {
    apiConfig: {
      type: Object,
      default() {
        return {};
      }
    },
    visible: {
      type: Boolean,
      default: function() {
        return false;
      }
    },
    width: {
      type: [String],
      default() {
        return "800";
      }
    },
    title: {
      type: String,
      default: function() {
        return "分组管理";
      }
    },
    type: {
      type: String,
      default: function() {
        return "success";
      }
    }
  },
  data() {
    return {
      name: "",
      search: {
        size: "small",
        labelConfig: {
          labelWidth: "90px",
          labelSuffix: ":",
          labelPosition: "right"
        },
        config: [
          {
            type: "text",
            placeholder: "请输入关键字搜索",
            className: "nameBox",
            bind: "name" // 对应this.search.data对象的field1
          }
        ],
        enum: {},
        btns: [],
        formData: {
          name: ""
        }
      },
      table: {
        data: [{ name: "123" }], // 表格数据
        tableConfig: {
          rowClassName: this.rowClassName,
          title: "表格的标题", // 表格标题
          highlightCurrentRow: false, // 控制表格是否单选
          // maxLength: 20, // 一行最多显示多少字，超出显示popver
          load: this.load,
          tooltipEffect: "light",
          header: [
            {
              label: "分类名称",
              prop: "name",
              isShow: true
            }
          ],
          selectionConfig: {
            display: false,
            width: "70"
          },
          indexConfig: {
            display: true,
            label: "序号",
            width: "70"
          },
          operateConfig: {
            display: false,
            label: "操作",
            width: "166",
            fixed: "right"
          },
          slotOperateConfig: {
            display: true,
            label: "操作",
            slotName: "slotOperateConfig"
          },
          innerBtn: [
            // 表格内部操作按钮，不需要操作列的innerBtn 写成false
            {
              name: "编辑", // 按钮名称，优先显示icon
              type: "text",
              size: "small",
              method: "edit", // 点击执行该页面methods中对应的方法
              icon: "iconbianji" // 按钮显示的图标,不传显示中文
            },
            {
              name: "删除",
              method: "delete",
              type: "text",
              size: "medium",
              icon: "el-icon-document",
              className: "font-size-20"
            }
          ]
        },
        page: {
          // 分页配置
          total: 0, //总条数
          pages: 0, //总页数
          pageSize: 10, //每页展示多少个
          pageSizes: [10, 20, 30],
          pageNum: 1, //当前页
          background: true
          // layout: 'total, prev, pager, next, sizes,jumper'
        }
      }
    };
  },
  methods: {
    //操作事件
    callFn(item, row, name, index) {
      if (item.method && item.method.constructor == Function) {
        // 兼容以前，扩展传入fn方式
        item.method(item, row, name, index);
        return;
      }
      let sum = 0;
      let obj = this.getDeepMethod(this, item.method, sum, 10);
      if (obj.parent && obj.method) {
        obj.method.call(obj.parent, row, name, index);
      }
    },
    // 递归找method
    getDeepMethod(parent, method, sum, limit) {
      sum++;
      if (!parent) {
        return {};
      } else if (sum == limit) {
        return {};
      } else if (parent[method]) {
        return {
          parent,
          method: parent[method]
        };
      } else {
        return this.getDeepMethod(parent.$parent, method);
      }
    },
    handleClose() {
      this.$emit("handleClose");
    },
    pageChanged(val) {
      this.table.page.pageNum = val;
      this.getTbData();
    },
    sizeChanged(val) {
      this.table.page.pageNum = 1;
      this.table.page.pageSize = val;
      this.getTbData();
    },
    getTbData(index) {
      if (index) {
        this.table.page.pageNum = index;
      }
      let params = {
        pageNum: this.table.page.pageNum,
        pageSize: this.table.page.pageSize,
        ...this.search.formData
      };
      if (this.params) {
        params = { ...params, ...this.params };
      }
      this.apiConfig.getTbData &&
        this.apiConfig.getTbData(params).then(res => {
          if (res.msg.code == "0000") {
            this.table.data = res.data.records;
          }
        });
    },
    edit(item, data) {
      console.log(item, data);
      this.name = data.name;
      this.id = data.id;
      this.popover_close("add");
    },
    delete(item, data, name) {
      console.log(item, data, name);
      this.$SrUtils.showConfirmMessage.call(this, {
        title: "删除",
        content: "删除分组后将无法恢复，请问您确认要删除此分组吗？",
        okFun: () => {
          this.apiConfig.delete &&
            this.apiConfig.delete({ id: item.id }).then(res => {
              if (res.msg.code == "0000") {
                this.$message.success("删除成功");
                this.getTbData(1);
              }
            });
        },
        cancelFun: () => {
          this.$message("已取消删除");
        }
      });
    },
    add() {
      this.name = "";
      this.id = "";
      this.popover_close("edit");
    },
    popover_sumbit(name) {
      this.popover_close(name);
      if (!this.name) {
        return;
      }
      let params = {
        name: this.name
      };
      if (this.id) {
        params.id = this.id;
      }
      this.apiConfig.submit &&
        this.apiConfig.submit(params).then(res => {
          if (res.msg.code == "0000") {
            if (this.id) {
              this.$message.success("编辑成功");
            } else {
              this.$message.success("新增成功");
            }
            this.getTbData(1);
          }
        });
    },
    popover_close(name) {
      let obj = {
        edit: this.$refs["SrDialogAddOptionsPopoverEdit"],
        add: this.$refs["SrDialogAddOptionsPopoverAdd"]
      };
      let list = obj[name];
      this.$nextTick(() => {
        if (list && list.length) {
          list.forEach(item => {
            item.doClose();
          });
        } else {
          list.doClose();
        }
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// packages/SrDialogAddOptions/SrDialogAddOptions.vue